































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency.js";
import {
  DrivewealthHolding,
  InstrumentStatus,
  DrivewealthAccountSummary, DrivewealthAccountManagementType
} from "@/shared/types";
import InstrumentName from "./InstrumentName.vue";
import * as RouteNames from "@/employee/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    InstrumentName,
    GenericLoadingSpinner
  }
})
export default class CurrentHoldingsTable extends mixins(ErrorsMixin) {
  formatCurrency = formatCurrency;

  drivewealthStore = useDrivewealthStore();

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  loadTable (): void {
    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2(
        { username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId });
    }
    this.drivewealthStore.loadAdvisoryFunds({ username: this.username, partnerId: this.partnerId });
  }

  @Watch("$props", { deep: true })
  reloadData (): void {
    this.loadTable();
  }

  mounted (): void {
    this.loadTable();
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  routeParams (symbol: string): { symbol: string, accountId?: number } {
    if (this.accountId) {
      return { symbol, accountId: this.accountId };
    }

    return { symbol };
  }

  get accountSummaryV2RequestLoaded (): boolean {
    return this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get isLoaded (): boolean {
    return this.accountSummaryV2RequestLoaded &&
      this.drivewealthStore.advisoryFundsLoaded;
  }

  holdingFields = [
    {
      key: "instrument",
      label: "Investment",
      thClass: "text-left pl-2",
      tdClass: "pl-2"
    },
    {
      key: "fund_type",
      label: "Fund Type",
      thClass: "text-center",
      tdClass: "text-center"
    },
    {
      key: "shares",
      label: "Shares",
      thClass: "text-right",
      tdClass: "text-right"
    },
    {
      key: "price",
      label: "Price",
      thClass: "text-right",
      tdClass: "text-right"
    },
    {
      key: "balance",
      label: "Balance",
      thClass: "text-right",
      tdClass: "text-right"
    },
    {
      key: "allocation",
      label: "Allocation",
      thClass: "text-right",
      tdClass: "text-right"
    },
    {
      key: "action",
      label: "",
      thClass: "text-center"
    }
  ];

  get holdingItems () {
    if (!this.accountSummaryV2) {
      return [];
    }

    return this.accountSummaryV2.holdings.map(h => ({
      instrument: { symbol: h.stockSymbol, companyName: h.fundName, website: h.webSite, imageUrl: h.imageUrl },
      fund_type: this.drivewealthStore.fundTypeDisplayCopy(h.fundType),
      shares: h.openQuantity.toFixed(2),
      price: formatCurrency(h.marketPrice),
      balance: formatCurrency(h.marketValue),
      percentage: (h.marketValue / this.accountSummaryV2.equityValue * 100).toFixed(2),
      action: { symbol: h.stockSymbol, canBuy: this.canBuyThisInstrument(h) }
    }));
  }

  canBuyThisInstrument (h: DrivewealthHolding): boolean {
    return h.status === InstrumentStatus.Active
      && (this.isSelfDirected || !!this.drivewealthStore.advisoryFundBySymbol(h.stockSymbol));
  }

  get buyRoute (): string {
    if (this.accountId) {
      return RouteNames.DrivewealthBuyInstrumentV2;
    }

    return RouteNames.DrivewealthBuyInstrument;
  }

  get sellRoute (): string {
    if (this.accountId) {
      return RouteNames.DrivewealthSellInstrumentV2;
    }

    return RouteNames.DrivewealthSellInstrument;
  }

  onSell (holding: DrivewealthHolding): void {
    alert(`Sell ${holding.stockSymbol}`);
  }

  get canBuySell () {
    return !this.username && !this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged, this.accountId);
  }

  get canBuySellPortfolio () {
    return !this.username && this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged, this.accountId);
  }

  get isSelfDirected (): boolean {
    return !this.username && this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.OpenBrokerage, this.accountId);
  }

  get hasPortfolio (): boolean {
    return this.accountSummaryV2RequestLoaded
      && this.accountSummaryV2.portfolioId !== null;
  }

  get isManagedAccount () {
    return this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged, this.accountId);
  }
}
